import type { HTMLAttributes } from "react";

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: "neutral" | "active" | "error";
}

export function Badge({ tone = "neutral", className = "", ...rest }: BadgeProps): JSX.Element {
  const tones = {
    neutral: "border-border text-ink-muted",
    active: "border-butter text-butter",
    error: "border-vinyl text-vinyl",
  };
  return (
    <span
      className={`inline-flex items-center border px-2 py-0.5 font-mono text-[10px] uppercase tracking-widest2 ${tones[tone]} ${className}`}
      {...rest}
    />
  );
}
